<template>
  <div class="details_content_repeat">
    <QS-h4-title title="车辆信息" />
    <QS-common-table
      :columns="carInfoHeader"
      :pagination="paginationData"
      :loading="loading"
      :data="carInfoList"
      @change="paginationChange"
    ></QS-common-table>
    <p class="txt-right">
      在租车辆数：{{payInfo.rentedCarNum || 0}} 台；
      订单退车数：{{payInfo.returnCarNum || 0}} 台
    </p>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import { getOrderCarList } from '@/api/domain/orders'

export default {
  props: {
    payInfo: {
      type: Object,
    },
  },
  data() {
    return {
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      carInfoList: [],
      carInfoHeader: [
        {
          name: 'index',
          columnProps: {
            label: '序号',
            width: 80,
          },
          getText: ({ $index }) => $index + this.paginationData.pageNum,
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 150,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期金额',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            prop: 'deposit',
            label: '押金',
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '收款开始日',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '收款结束日',
          },
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '子订单状态',
          },
          getText: ({ row }) => { return selectOption.leaseOrderState[row.state] },
        },
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '子订单ID',
          },
          render: ({ row }) => (
            this.judgePermission('workbench_ent_rent_order_sub_detail')
              ? <el-button
                type="text"
                onClick={() => { this.handleOrderIdClick(row.id) }}>{row.id}</el-button>
              : row.id
          ),
        },
      ],
      loading: false,
    }
  },
  methods: {
    // 点击id新开浏览器跳转详情页
    handleOrderIdClick(id) {
      const routeUrl = this.$router.resolve({
        name: 'workbench_ent_rent_order_sub_detail',
      })
      this.$router.push({
        path: routeUrl.href,
        query: { id },
      })
    },
    async getCarList() {
      this.loading = true
      const { code, data } = await getOrderCarList({
        id: this.payInfo.id,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      })
      this.loading = false
      if (code === 1) {
        this.carInfoList = data.items
        this.paginationData.pageNum = data.pageNum
        this.paginationData.total = data.totalNum
      }
    },
    paginationChange({ pagination }) {
      const { pageNum, pageSize } = pagination
      this.paginationData.pageNum = pageNum
      this.paginationData.pageSize = pageSize
      this.getCarList()
    },
  },
  watch: {
    'payInfo.id': {
      handler(newVal) {
        if (newVal) {
          this.getCarList()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  .txt-right{
    text-align: right;
  }
  .processing {
    cursor: pointer;
  }
</style>
